const allowedTags = ["p", "strong", "em", "blockquote", "ul", "ol", "li", "span", "img"];
export default allowedTags;
